// Generated with util/create-component.js
import Label from './Label';

export default Label;
